module.exports = __webpack_public_path__ + "static/favicon-d129c12cc338f8878952c44b63de9353.png";